module.exports = __webpack_public_path__ + "img/image_1.78b7f9d4.jpg";